var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BaseInput',_vm._b({staticClass:"mb-4 d-block",attrs:{"type":"text","value":_vm.value,"placeholder":"Pesquisa por CPF, CNPJ ou e-mail"},on:{"input":_vm.onInput}},'BaseInput',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }